import React from 'react'
import { useCollapsible } from './use-collapsible'
import { ChevronRight } from 'lucide-react'
import { mergeClasses } from '@/helpers/styling'

export function CollapsibleSection(props: {
  id: string
  header: string | React.ReactNode
  children: React.ReactNode
  defaultExpanded?: boolean
}) {
  const [ collapsibleState, toggle ] = useCollapsible(props.id, props.defaultExpanded)
  const isExpanded = collapsibleState === "expanded"
  return (
    <div className="flex flex-col border-b border-border">
      <button type="button"
              aria-expanded={isExpanded}
              onClick={toggle}
              className={`
                group flex items-center gap-2 px-2 py-2.5 cursor-pointer select-none text-left
                font-exo text-[13px] font-semibold text-foreground/80 hover:text-foreground`}>
        <ChevronRight size={14}
                      className={mergeClasses("shrink-0 text-muted-foreground transition-transform duration-150", {
                        "rotate-90": isExpanded
                      })} />
        <div className="flex-grow">
          {props.header}
        </div>
      </button>
      <div
        className={mergeClasses(
          "grid transition-all duration-150 ease-in-out", {
          "opacity-100 grid-rows-[1fr] pointer-events-auto": isExpanded,
          "opacity-0   grid-rows-[0fr] pointer-events-none": !isExpanded
        })}>
        <div className={mergeClasses(
          `
          flex flex-col gap-2.5 px-2
          transition-[padding] duration-150 ease-in-out
          `, {
            "pt-0.5 pb-3": isExpanded,
            "overflow-hidden py-0": !isExpanded,
          }
        )}>
          {props.children}
        </div>
      </div>
    </div>
  )
}
